import { map } from "lodash";

import {
	INITIAL_LOGIN_REQUEST,
	FINAL_LOGIN_REQUEST,
	LOGIN_SUCCESS,
	LOGIN_ERROR,
	LOGOUT_SUCCESS,
	LOGOUT_ERROR,
	CLEAR_STORE,
	UPDATE_NOTIFICATIONS,
	INITIAL_LOGOUT_REQUEST,
} from "../types/auth.types";

import { SET_MESSAGE } from "../types/message.types";
import AuthService from "@/services/auth.service";
import { textConstants } from "@/languages/textConstants";

import useFilterStore from "@/stores/useFilterStore";
import useUserStore from "@/stores/useUserStore";

export const authLogin = (username, password) => (dispatch) => {
	dispatch({ type: INITIAL_LOGIN_REQUEST });

	return AuthService.login(username, password)
		.then((response) => {
			const { data, screens_option, notifications, dashboard, survey, season, customers } = response;

			const filter = {
				estate_parent_id: data && data.estates_parents.length !== 0 ? map(data.estates_parents, "value").toString() : "",
				estate_id: data && data.estates.length !== 0 ? map(data.estates, "value").toString() : "",
				type_currency: textConstants[data.customer.country_id] ? textConstants[data.customer.country_id].currency : "USD",
				search: "",
				application: "",
				parameter: "",
				season_id: season ? season.value : null,
			};

			const user = {
				user_id: data.user_id,
				customer_id: data.customer.id,
				name: data.full_name,
				customer_name: data.customer.name,
				superuser: data.superuser,
			};

			useFilterStore.getState().updateFilter(filter);
			useUserStore.getState().setUser(user);

			dispatch({
				type: LOGIN_SUCCESS,
				payload: {
					user: data,
					screens_option: screens_option,
					notifications: notifications,
					token: data.authorization,
					filter: filter,
					dashboard: dashboard,
					survey: survey,
					season: season,
					customers: customers,
				},
			});

			dispatch({
				type: SET_MESSAGE,
				payload: {
					message: `Bienvenido nuevamente ${response.data.full_name}`,
					type: "success",
				},
			});

			return Promise.resolve(response.data);
		})
		.catch((_error) => {
			dispatch({ type: INITIAL_LOGIN_REQUEST });
			dispatch({ type: CLEAR_STORE });

			const message = "Los datos ingresados no corresponden, verifique usuario y contraseña";

			dispatch({
				type: LOGIN_ERROR,
				payload: {
					error: message,
				},
			});

			dispatch({
				type: SET_MESSAGE,
				payload: {
					message: message,
					type: "error",
				},
			});

			localStorage.removeItem("user");
			localStorage.removeItem("superuser");
			localStorage.removeItem("token");
			localStorage.removeItem("expiration_date");
			localStorage.removeItem("roles");

			return Promise.reject();
		});
};

export const authLogout = () => async (dispatch) => {
	try {
		dispatch({ type: INITIAL_LOGOUT_REQUEST });
		await AuthService.logout();
		dispatch({ type: CLEAR_STORE });
		dispatch({
			type: LOGOUT_SUCCESS,
			payload: {},
		});

		localStorage.removeItem("user");
		localStorage.removeItem("superuser");
		localStorage.removeItem("token");
		localStorage.removeItem("expiration_date");
		localStorage.removeItem("roles");
		return await Promise.resolve();
	} catch {
		const message = "Error al cerrar sesión, por favor comunique con administración";

		dispatch({
			type: LOGOUT_ERROR,
			payload: {
				error: message,
			},
		});

		dispatch({
			type: SET_MESSAGE,
			payload: {
				message: message,
				type: "error",
			},
		});
		return await Promise.reject();
	}
};

export const authForgotPassword = (email) => (dispatch) => {
	dispatch({ type: INITIAL_LOGIN_REQUEST });

	return AuthService.forgot_password(email)
		.then((response) => {
			dispatch({ type: FINAL_LOGIN_REQUEST });

			dispatch({
				type: SET_MESSAGE,
				payload: {
					message: response.data.message,
					type: "success",
				},
			});

			return Promise.resolve();
		})
		.catch((error) => {
			dispatch({ type: FINAL_LOGIN_REQUEST });

			let message = "Se ha producido un error inesperado, por favor comunique con administración.";
			if (error.response.data.data) {
				message = error.response.data.data.message;
			}
			dispatch({
				type: SET_MESSAGE,
				payload: {
					message: message,
					type: "error",
				},
			});

			return Promise.reject();
		});
};

export const changePassword = (password, token) => (dispatch) => {
	dispatch({ type: INITIAL_LOGIN_REQUEST });

	return AuthService.change_password(password, token)
		.then((response) => {
			dispatch({ type: FINAL_LOGIN_REQUEST });

			dispatch({
				type: SET_MESSAGE,
				payload: {
					message: response.data.message,
					type: "success",
				},
			});

			return Promise.resolve();
		})
		.catch((error) => {
			dispatch({ type: FINAL_LOGIN_REQUEST });

			dispatch({
				type: SET_MESSAGE,
				payload: {
					message: error.response.data.data.message,
					type: "error",
				},
			});

			return Promise.reject();
		});
};

export const notificationSeen = (notification_id) => (dispatch) => {
	return AuthService.notification_seen(notification_id)
		.then((response) => {
			dispatch({
				type: UPDATE_NOTIFICATIONS,
				payload: {
					notifications: response.notifications,
				},
			});

			return Promise.resolve(response);
		})
		.catch((_error) => {
			return Promise.reject();
		});
};

export const notificationMultipleSeen = (notifications) => (dispatch) => {
	return AuthService.notification_multiple_seen(notifications)
		.then((response) => {
			dispatch({
				type: UPDATE_NOTIFICATIONS,
				payload: {
					notifications: response.notifications,
				},
			});

			return Promise.resolve(response);
		})
		.catch((_error) => {
			return Promise.reject();
		});
};
